import { render } from "./sectors.vue?vue&type=template&id=12bddaae&scoped=true"
import script from "./sectors.vue?vue&type=script&lang=js"
export * from "./sectors.vue?vue&type=script&lang=js"

import "./sectors.vue?vue&type=style&index=0&id=12bddaae&lang=scss"
import "./sectors.vue?vue&type=style&index=1&id=12bddaae&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bddaae"]])

export default __exports__